import { Box, Typography } from '@mui/material'
import dccFalse from 'assets/branch/setting/dccFalse.png'
import dccTrue from 'assets/branch/setting/dccTrue.png'
import { DCC_TREATMENT_COST } from 'constants/status'
import { useTranslation } from 'react-i18next'

const OpShowDccTreatmentCost = () => {
    const { t } = useTranslation()
    const optionDccTreatmentCost = [
        {
            name: t('BRANCH.TAB.SENTTING.PATTERN_DCC_TREATMENT_COST.SHOW'), value: DCC_TREATMENT_COST.SHOW,
            component: <DccTreatmentCost showType='1' />,
        },
        {
            name: t('BRANCH.TAB.SENTTING.PATTERN_DCC_TREATMENT_COST.NOT_SHOW'), value: DCC_TREATMENT_COST.NOT_DISPLAYED,
            component: <DccTreatmentCost showType='0' />,
        }
    ]
    return (optionDccTreatmentCost)
}

export default OpShowDccTreatmentCost

interface DccTreatmentCostProps {
    showType: '0' | '1'
}
const DccTreatmentCost = (props: DccTreatmentCostProps) => {
    const { showType } = props
    const { t } = useTranslation()

    return (
        <Box display='flex' flexDirection='column' gap='16px' height='100%'>
            <Box marginBottom={showType === '0' ? '0px' : '16px'}>
                <Typography fontSize={'20px'} fontWeight={'500'} marginBottom={showType === '1' ? '0px' : '8px'}>
                    {t('BRANCH.TAB.SENTTING.DCC_TREATMENT_COST')}
                </Typography>
            </Box>
            <Box display='flex' alignItems={'center'} gap={'16px'} flexDirection={'column'} >
                <Box textAlign='center' sx={{ img: { width: '80%' } }}>
                    <img src={showType === '0' ? dccFalse : dccTrue} alt="" />
                </Box>
            </Box>
            <Box>
                <Typography fontSize={'16px'} fontWeight={'500'} marginBottom='8px'>
                    {t(`BRANCH.TAB.SENTTING.PATTERN_DCC_TREATMENT_COST.${showType === '1' ? 'SHOW' : 'NOT_SHOW'}`)}
                </Typography>
                <Typography fontWeight={'400'} paddingLeft='16px' color='#5A5A5A'>
                    {t(`BRANCH.TAB.SENTTING.PATTERN_DCC_TREATMENT_COST.${showType === '1' ? 'SUB_PATTERN' : 'NOT_SUB_PATTERN'}`)}
                </Typography>
            </Box>
        </Box>
    )
}
